import { createFileRoute } from '@tanstack/react-router';
import { CheckCircle2 } from 'lucide-react';
import { Navbar } from '@/components/sections/navbar';
import { SiteFooter } from '@/components/sections/site-footer';
import { useLang } from '@/lib/LanguageContext';
import { ta } from '@/lib/i18n';
import { t } from '@/lib/translations';

export function MerciPage() {
  const { lang } = useLang();
  const text = ta(t.merci, lang);

  return (
    <div className="flex min-h-[100dvh] flex-col bg-background text-foreground">
      <Navbar />
      <main className="flex flex-grow items-center py-16 md:py-24">
        <div className="mx-auto max-w-2xl px-5 text-center">
          <CheckCircle2 className="mx-auto mb-6 h-16 w-16 text-secondary" aria-hidden="true" />
          <span className="mb-4 block font-display text-base italic tracking-wide text-secondary">
            {text.eyebrow}
          </span>
          <h1 className="mb-8 font-display text-4xl leading-[1.15] text-balance text-foreground md:text-5xl">
            {text.title}
          </h1>
          <p className="mb-10 font-sans text-base leading-relaxed text-pretty hyphens-auto text-muted-foreground md:text-lg">
            {text.body}
          </p>
          <div className="mb-8 flex flex-col items-center justify-center gap-4 md:flex-row">
            <a
              href="/guides/amg-quebec-2026.pdf"
              download
              className="shadow-warm-soft hover:shadow-warm-md inline-flex w-full items-center justify-center rounded-md bg-primary px-6 py-3 font-sans text-sm font-bold uppercase tracking-widest text-primary-foreground transition-all hover:bg-primary/90 md:w-auto"
            >
              {text.cta_guide}
            </a>
            <a
              href="/carnet"
              className="inline-flex w-full items-center justify-center rounded-md border border-secondary px-6 py-3 font-sans text-sm font-bold uppercase tracking-widest text-secondary-foreground transition-colors hover:bg-secondary/10 md:w-auto"
            >
              {text.cta_articles}
            </a>
          </div>
          <p className="font-sans text-sm italic text-muted-foreground">{text.urgent_note}</p>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}

export const Route = createFileRoute('/merci')({
  component: MerciPage
});
